//-------------
// load traits
//--------------
import store from '../store/index'

export default function loadTraits({ character }) {
  console.log('---------------------------------------------------')
  console.log('IN loadTraits')
  /*
    traits are loaded from:
    - character.race.trait
    - character.runes[n].trait
    NB: only active/unique runes with traits are loaded
  */
  //----------
  // get args
  //----------
  character = character ?? {}

  //-------------------------------
  // declare array first time thru
  //-------------------------------
  if (!('traits' in character)) {
    console.log('initialising character.traits array')
    character.traits = []
    //--------------------------------------------------------------------------
    // clear existing (for local updates prior to db updates e.g. rune changes)
    //--------------------------------------------------------------------------
  } else {
    console.log('clearing existing character.traits array')
    character.traits.splice(0)
  }
  //----------------
  // get race trait
  //----------------
  const race_name = character.race_name || null
  const race_trait = character.race_trait || null
  const hasTraitValue = (value) => {
    if (value == null) return false
    if (typeof value === 'string') return value.trim() !== ''
    return true
  }
  // console.log('character race = ', window.$deepCopy(character))
  // console.log('race_name = ' + race_name)
  // console.log('race_trait = ' + race_trait)
  //-------------------------------------------------
  // get rune traits (active runes with traits only)
  //-------------------------------------------------
  const rune_traits = character.runes
    ? character.runes
        .filter((r) => hasTraitValue(r.trait) && r.active == true)
        .map((r) => ({ name: r.name, trait: r.trait }))
    : []
  const getStaticItemById = store.getters?.['characters/getStaticItemById']
  const item_traits = Array.isArray(character.items)
    ? character.items.flatMap((item) => {
        if (!item) return []

        const sourceLabel = item.display_name || item.name || 'Item'
        const itemTraitRows = Array.isArray(item.item_traits)
          ? item.item_traits
          : typeof getStaticItemById === 'function' && item.item
            ? (getStaticItemById(item.item)?.item_traits ?? [])
            : []

        return itemTraitRows
          .filter((trait) => hasTraitValue(trait?.description) || hasTraitValue(trait?.name))
          .map((trait) => ({
            source: sourceLabel,
            description: trait?.name || trait?.description || '',
          }))
      })
    : []
  // console.log('RACE TRAIT:', race_trait)
  // console.log('RUNE TRAITS:', rune_traits)
  //-------------
  // load traits
  //-------------
  if (hasTraitValue(race_trait)) {
    const trait_entry = {
      source: `Race (${race_name})`,
      description: race_trait,
    }
    character.traits.push(trait_entry)
    // console.log('++++++++ ADDED RACE TRAIT ENTRY = ', trait_entry)
  }
  rune_traits.forEach((r) => {
    // check for existing runes to avoid dupes (could have multiple active runes with same name)
    const existing_trait = character.traits.find((t) => t.source === `${r.name} (Active)`)

    if (!existing_trait) {
      const trait_entry = {
        source: `${r.name} (Active)`,
        description: r.trait,
      }
      character.traits.push(trait_entry)
      // console.log('++++++++ ADDED RUNE TRAIT ENTRY = ', trait_entry)
    }
  })
  item_traits.forEach((trait_entry) => {
    const existing_trait = character.traits.find(
      (t) => t.source === trait_entry.source && t.description === trait_entry.description,
    )

    if (!existing_trait) {
      character.traits.push(trait_entry)
      // console.log('++++++++ ADDED ITEM TRAIT ENTRY = ', trait_entry)
    }
  })
  // sort rune-derived traits by source but keep race trait (if any) at top
  if ((rune_traits.length > 0 || item_traits.length > 0) && Array.isArray(character.traits)) {
    const raceIndex = character.traits.findIndex(
      (t) => typeof t?.source === 'string' && t.source.startsWith('Race ('),
    )

    let raceTrait = null
    let otherTraits = character.traits

    if (raceIndex !== -1) {
      raceTrait = character.traits[raceIndex]
      otherTraits = character.traits.filter((_, idx) => idx !== raceIndex)
    }

    otherTraits.sort((a, b) => {
      const aSource = a?.source ?? ''
      const bSource = b?.source ?? ''
      return aSource.localeCompare(bSource)
    })

    character.traits = raceTrait ? [raceTrait, ...otherTraits] : otherTraits
  }
  console.log('END loadTraits')
  //-------------------------------------------------------------
  // return mutated objects for clarity (optional use by callers
  //-------------------------------------------------------------
  return character
}
